const VerticalPermissions = {
  edit: 'vertical:edit',
  create: 'vertical:create',
  delete: 'vertical:delete',
  view: 'vertical:view',
}

export default VerticalPermissions
